module.exports = __webpack_public_path__ + "img/es.2983be30.png";